import { WEBRTC_SIGNAL_KINDS } from "../nearbyTransfer.constants";
import {
  createLocalPeerConnection,
  createTransferDataChannel,
} from "../../localTransfer/utils/webrtc";
import { normalizeSessionDescription } from "../../localTransfer/utils/sdp";

const normalizeCandidate = (candidate) =>
  typeof candidate.toJSON === "function" ? candidate.toJSON() : candidate;

const relayIceCandidates = ({ peerConnection, onSignal }) => {
  peerConnection.onicecandidate = (event) => {
    if (!event.candidate) return;

    onSignal({
      kind: WEBRTC_SIGNAL_KINDS.ICE_CANDIDATE,
      candidate: normalizeCandidate(event.candidate),
    });
  };
};

export const createRequesterPeer = async ({ onChannel, onSignal }) => {
  const peerConnection = createLocalPeerConnection();
  relayIceCandidates({ peerConnection, onSignal });
  onChannel(createTransferDataChannel(peerConnection));

  const offer = await peerConnection.createOffer();
  await peerConnection.setLocalDescription(offer);
  const offerDescription = normalizeSessionDescription(peerConnection.localDescription);
  onSignal({ kind: WEBRTC_SIGNAL_KINDS.OFFER, description: offerDescription });

  return { peerConnection, offerDescription };
};

export const createReceiverPeer = async ({
  offerDescription,
  onChannel,
  onSignal,
}) => {
  const peerConnection = createLocalPeerConnection();
  relayIceCandidates({ peerConnection, onSignal });
  peerConnection.ondatachannel = (event) => onChannel(event.channel);

  await peerConnection.setRemoteDescription(offerDescription);
  const answer = await peerConnection.createAnswer();
  await peerConnection.setLocalDescription(answer);
  const answerDescription = normalizeSessionDescription(peerConnection.localDescription);
  onSignal({ kind: WEBRTC_SIGNAL_KINDS.ANSWER, description: answerDescription });

  return { peerConnection, answerDescription };
};

export const applyAnswerDescription = async ({ peerConnection, description }) => {
  await peerConnection.setRemoteDescription(description);
};

export const addRemoteIceCandidate = async ({ peerConnection, candidate }) => {
  if (!candidate) return;

  await peerConnection.addIceCandidate(candidate);
};
